/**
 * @name classy
 * @description This converts the list of string-arguments to a className string
 * @param args
 */
export default function classy(
  ...args: (string | undefined | null | boolean)[]
): string {
  return args
    .filter((item) => typeof item === 'string' && item.trim().length > 0)
    .join(' ')
}
